import { z } from 'zod'

export enum InvoiceAddressType {
  CONTRACT_ADDRESS = 'contract_address',
  CORPORATE_ELECTRONIC = 'corporate_electronic',
  POSTAL_INVOICE_ADDRESS = 'postal_invoice_address',
}

const postalAddressWithRecipientNameSchema = z.object({
  city: z.string(),
  countryCode: z.string().nullable(),
  countryName: z.string(),
  id: z.number(),
  invoiceRecipientName: z.string().nullable(),
  postalCode: z.string(),
  streetAddressLine1: z.string(),
  streetAddressLine2: z.string().nullable(),
})

export const invoiceAddressSchema = z.object({
  contractAddress: postalAddressWithRecipientNameSchema.nullable(),
  electronicInvoiceAddress: z
    .object({
      businessIdentityCode: z.string().nullable(),
      companyName: z.string().nullable(),
      id: z.string(),
      identifier: z.string(),
      intermediator: z.string(),
    })
    .nullable(),
  postalInvoiceAddress: postalAddressWithRecipientNameSchema.nullable(),
  selectedInvoiceType: z.nativeEnum(InvoiceAddressType),
  selectedPostalAddressType: z.nativeEnum(InvoiceAddressType),
})

export type InvoiceAddress = z.infer<typeof invoiceAddressSchema>
